module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-left.d53975a7.svg";